import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Bell, AlertTriangle, Eye, TrendingUp, TrendingDown, Activity } from 'lucide-react';

export function WhaleStats() {
  // Mock stats - will be replaced with real-time data
  const stats = {
    totalAlertsToday: 47,
    criticalAlerts: 3,
    trackedWallets: 156,
    totalVolumeTracked: '847.5M',
    topMovingToken: {
      symbol: 'ETH',
      volume: '$234.5M',
      direction: 'out' as const,
    },
    exchangeNetFlow: {
      value: '-$145.2M',
      isNegative: true,
    },
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-slate-600 dark:text-slate-400">Alertas Hoy</p>
              <p className="text-2xl font-bold text-slate-900 dark:text-slate-100">
                {stats.totalAlertsToday}
              </p>
            </div>
            <div className="p-2 bg-blue-500/20 rounded-lg">
              <Bell className="h-5 w-5 text-blue-500" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="border-red-500/30">
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-slate-600 dark:text-slate-400">Alertas Criticas</p>
              <p className="text-2xl font-bold text-red-500">
                {stats.criticalAlerts}
              </p>
            </div>
            <div className="p-2 bg-red-500/20 rounded-lg animate-pulse">
              <AlertTriangle className="h-5 w-5 text-red-500" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-slate-600 dark:text-slate-400">Wallets Rastreadas</p>
              <p className="text-2xl font-bold text-slate-900 dark:text-slate-100">
                {stats.trackedWallets}
              </p>
            </div>
            <div className="p-2 bg-violet-500/20 rounded-lg">
              <Eye className="h-5 w-5 text-violet-500" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-slate-600 dark:text-slate-400">Volumen 24h</p>
              <p className="text-2xl font-bold text-slate-900 dark:text-slate-100">
                ${stats.totalVolumeTracked}
              </p>
            </div>
            <div className="p-2 bg-green-500/20 rounded-lg">
              <Activity className="h-5 w-5 text-green-500" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-slate-600 dark:text-slate-400">Top Token</p>
              <p className="text-xl font-bold text-slate-900 dark:text-slate-100">
                {stats.topMovingToken.symbol}
              </p>
              <p className="text-xs text-slate-600 dark:text-slate-400">
                {stats.topMovingToken.volume}
              </p>
            </div>
            <div className={`p-2 rounded-lg ${stats.topMovingToken.direction === 'out' ? 'bg-red-500/20' : 'bg-green-500/20'}`}>
              {stats.topMovingToken.direction === 'out' ? (
                <TrendingDown className="h-5 w-5 text-red-500" />
              ) : (
                <TrendingUp className="h-5 w-5 text-green-500" />
              )}
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-slate-600 dark:text-slate-400">Exchange Net Flow</p>
              <p className={`text-xl font-bold ${stats.exchangeNetFlow.isNegative ? 'text-green-500' : 'text-red-500'}`}>
                {stats.exchangeNetFlow.value}
              </p>
              <p className="text-xs text-slate-600 dark:text-slate-400">
                {stats.exchangeNetFlow.isNegative ? 'Acumulacion' : 'Distribucion'}
              </p>
            </div>
            <div className={`p-2 rounded-lg ${stats.exchangeNetFlow.isNegative ? 'bg-green-500/20' : 'bg-red-500/20'}`}>
              {stats.exchangeNetFlow.isNegative ? (
                <TrendingUp className="h-5 w-5 text-green-500" />
              ) : (
                <TrendingDown className="h-5 w-5 text-red-500" />
              )}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
